import { Button } from "antd";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";

import DarkLogo from "../../../assets/icons/404-dark.svg";
import LightLogo from "../../../assets/icons/404-light.svg";
import {
    StyledNotFound,
    StyledNotFoundBlock,
    StyledNotFoundImage,
} from "./Styled";

const NotFound = () => {
    const navigate = useNavigate();
    const themeType = useAppSelector((state) => state.theme.type);

    const handleReload = useCallback(() => {
        window.location.reload();
    }, []);

    const handleGoBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return (
        <StyledNotFound>
            <StyledNotFoundBlock>
                <PrimaryText
                    fontSize={100}
                    fontWeight="500"
                    style={{
                        textAlign: "center",
                        lineHeight: "121px",
                        marginTop: 40,
                    }}
                    as="h1"
                >
                    404
                </PrimaryText>
                <PrimaryText
                    fontSize={20}
                    fontWeight="500"
                    style={{ textAlign: "center", marginTop: 64 }}
                >
                    Помилка завантаження
                </PrimaryText>
                <SecondaryText
                    fontSize={14}
                    fontWeight="400"
                    style={{ textAlign: "center", marginTop: 8, maxWidth: 301 }}
                >
                    Сторінку не вдалося завантажити. Будь ласка, перевірте
                    підключення до інтернету або спробуйте ще раз пізніше.
                </SecondaryText>
            </StyledNotFoundBlock>

            <StyledNotFoundImage
                src={themeType === "dark" ? DarkLogo : LightLogo}
                alt="Логотип"
            />

            <StyledNotFoundBlock style={{ marginTop: "50px" }}>
                <Button
                    type="primary"
                    onClick={handleReload}
                    aria-label="Перезавантажити сторінку"
                >
                    Перезавантажити сторінку
                </Button>
                <Button
                    type="default"
                    onClick={handleGoBack}
                    aria-label="Повернутися назад"
                    style={{ marginTop: "10px" }}
                >
                    Повернутися назад
                </Button>
            </StyledNotFoundBlock>
        </StyledNotFound>
    );
};

export default NotFound;
